import { ShortBreakMode } from 'app/constants/configuration/shortBreakMode'

export const getShortBreakMode = (type: number): ShortBreakMode => {
  let shortBreakMode = ShortBreakMode.BySchedule

  switch (type) {
    case 1:
      shortBreakMode = ShortBreakMode.ByActivities
      break
  }

  return shortBreakMode
}
